var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useRef, useContext, createContext } from 'react';
var AdornmentContext = createContext({});
var AdornmentProvider = function (_a) {
    var children = _a.children;
    var _b = __read(useState('right'), 2), position = _b[0], setPosition = _b[1];
    var _c = __read(useState(true), 2), isMasked = _c[0], setMasked = _c[1];
    var _d = __read(useState(''), 2), inputValue = _d[0], setInputValue = _d[1];
    var _e = __read(useState(false), 2), isBlurred = _e[0], setIsBlurred = _e[1];
    var _f = __read(useState({
        current: undefined,
    }), 2), inputRef = _f[0], setInputRef = _f[1];
    var _g = __read(useState({
        current: undefined,
    }), 2), maskRef = _g[0], setMaskRef = _g[1];
    var _h = __read(React.useState(null), 2), onBlurRelatedTarget = _h[0], setOnBlurRelatedTarget = _h[1];
    var staticCallback = useRef();
    var clickCallback = staticCallback.current;
    return (React.createElement(AdornmentContext.Provider, { value: {
            position: position,
            setPosition: setPosition,
            inputValue: inputValue,
            setInputValue: setInputValue,
            isMasked: isMasked,
            setMasked: setMasked,
            maskRef: maskRef,
            setMaskRef: setMaskRef,
            isBlurred: isBlurred,
            setIsBlurred: setIsBlurred,
            inputRef: inputRef,
            setInputRef: setInputRef,
            clickCallback: clickCallback,
            setClickCallback: function (value) {
                staticCallback.current = value;
            },
            onBlurRelatedTarget: onBlurRelatedTarget,
            setOnBlurRelatedTarget: setOnBlurRelatedTarget,
        } }, children));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var containsDefinedValue = function (values) {
    return values.some(function (value) { return value !== undefined; });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var checkContextValues = function (values, hookName) {
    if (!containsDefinedValue(values)) {
        throw new Error("".concat(hookName, " must be called within a child of the AdornmentProvider"));
    }
};
var useAdornmentState = function () {
    var _a = useContext(AdornmentContext), position = _a.position, setPosition = _a.setPosition, inputValue = _a.inputValue, setInputValue = _a.setInputValue, isBlurred = _a.isBlurred, setIsBlurred = _a.setIsBlurred, inputRef = _a.inputRef, setInputRef = _a.setInputRef, onBlurRelatedTarget = _a.onBlurRelatedTarget, setOnBlurRelatedTarget = _a.setOnBlurRelatedTarget;
    checkContextValues([position, setPosition, inputValue, setInputValue], 'useAdornmentState');
    return {
        position: position,
        setPosition: setPosition,
        inputValue: inputValue,
        setInputValue: setInputValue,
        isBlurred: isBlurred,
        setIsBlurred: setIsBlurred,
        inputRef: inputRef,
        setInputRef: setInputRef,
        onBlurRelatedTarget: onBlurRelatedTarget,
        setOnBlurRelatedTarget: setOnBlurRelatedTarget,
    };
};
var usePasswordMaskAdornment = function () {
    var _a = useContext(AdornmentContext), isMasked = _a.isMasked, setMasked = _a.setMasked, inputValue = _a.inputValue, maskRef = _a.maskRef, setMaskRef = _a.setMaskRef;
    checkContextValues([isMasked, setMasked, inputValue], 'usePasswordMaskAdornment');
    return { isMasked: isMasked, setMasked: setMasked, inputValue: inputValue, maskRef: maskRef, setMaskRef: setMaskRef };
};
var useSearchAdornment = function () {
    var _a = useContext(AdornmentContext), clickCallback = _a.clickCallback, setClickCallback = _a.setClickCallback;
    checkContextValues([clickCallback, setClickCallback], 'useSearchAdornment');
    return { clickCallback: clickCallback, setClickCallback: setClickCallback };
};
export { AdornmentProvider, AdornmentContext, useAdornmentState, usePasswordMaskAdornment, useSearchAdornment, };
//# sourceMappingURL=AdornmentProvider.js.map